export default __webpack_public_path__ + "static/media/dopes2.a7b5667c.jfif";